import React from "react";
import "./empty_state.scss";
import { Empty } from "antd";

function EmptyState() {
  return <Empty className="empty-comp" description="No records found!" />;
}

export default EmptyState;
